module.exports = __webpack_public_path__ + "img/stage_order_processing.674152f1.svg";